// use @mui/styles instead of @material-ui/core/styles since we want to override material-ui styles
import { makeStyles } from "@mui/styles";
import fonts from "~/shared/styles/fonts.css";

export const kickNavy = "#1e2347";
export const kickYellow = "#ffdd00";
export const kickPink = "#ffb7ad";
export const kickSlate = "#8096ab";
export const kickBlue = "#3f3f82";
export const kickGreen = "#30544f";
export const kickRed = "#f25930";

export const kickLightYellow = "#fff7e5";
export const kickLightPink = "#fff2f0";
export const kickLightSlate = "#f7fcff";
export const kickLightBlue = "#f4f2f9";
export const kickLightGreen = "#f2f9f7";
export const kickLightTan = "#f9f9f9";

export const kickColors = {
  navy: kickNavy,
  yellow: kickYellow,
  pink: kickPink,
  slate: kickSlate,
  blue: kickBlue,
  green: kickGreen,
  red: kickRed,
  lightYellow: kickLightYellow,
  lightPink: kickLightPink,
  lightSlate: kickLightSlate,
  lightBlue: kickLightBlue,
  lightGreen: kickLightGreen,
  lightTan: kickLightTan,
};

// width of sidebar navigation drawer
export const drawerWidth = 240;
export const headerHeight = "80px";

export const usePortalStyles = makeStyles(
  (theme) => ({
    // export const portalStyles = (theme) => ({
    kickContainer: {
      fontFamily: "BasisGrotesquePro-Regular",
    },
    wrapper: {
      height: "auto",
      minHeight: "100vh",
      position: "relative",
      top: "0",
    },
    gradiantBackground: {
      background: `radial-gradient(circle at 100% 100%, rgba(lightblue, 0.8),rgba(pink, 0.05)),
      radial-gradient(circle at 100% 0%, rgba(#e3ade6, 0.05), rgba(#e3ade6, 0.8)),
      radial-gradient(circle at 20% 50%, rgba(yellow, 0.5), rgba(pink, 0.1))`,
    },
    baseTypography: {
      fontFamily: "BasisGrotesquePro-Regular",
    },
    baseTab: {
      fontFamily: "BasisGrotesquePro-Bold",
    },
    baseTabLabel: {
      textTransform: "capitalize",
      letterSpacing: "0.03em",
    },
    mainContent: {
      marginTop: headerHeight,
      display: "flex",
      minHeight: `calc(100vh - ${headerHeight})`,
      [theme.breakpoints.up("sm")]: {
        marginLeft: drawerWidth,
        flexShrink: 0,
      },
    },
    content: {
      // flexGrow: 1,
      // padding: theme.spacing(3),
      height: `calc(100vh - ${headerHeight})`,
      width: "100%",
    },
    patientIndexPaginateRootCurrent: { color: "#f25930" },
    patientShowBody: {
      ...usePortalStyles.baseTypography,
      color: "white",
      letterSpacing: "0.02em",
    },
    patientTab: {
      ...usePortalStyles.baseTab,
      backgroundColor: "white",
      flex: 1,
      // border: "1px solid red"
    },
  }),
  { index: 1 } // https://stackoverflow.com/questions/62473898/material-ui-rendering-bugs-in-production-build
);

// export const useStyles = makeStyles(theme => ({
//   root: props => ({
//     backgroundColor: props.backgroundColor,
//     color: theme.color,
//   }),
// }));
